import React from "react"
import {MainCP} from "../../Components/expectativas2024/MainCP"

const ViewExpectativa2024: React.FC = () => <MainCP/>

export default ViewExpectativa2024;